// extracted by mini-css-extract-plugin
module.exports = {"section":"_93444fe79c--section--W2MK5","left-column":"_93444fe79c--left-column--OOnwy","right-column":"_93444fe79c--right-column--XWlCF"};